<template>
  <div :class="filtered ? 'container-fluid product-wrapper sidebaron' : 'container-fluid product-wrapper'">
    <div class="product-grid">
      <div class="feature-products">
        <BaseFilter
          screenKey="customer-rank-list-page"
          :model-value="allParams"
          @update:model-value="val => Object.assign(allParams, val)"
          :fields="filterConfig"
          @search="handleSearch"
          @reset="handleReset"
        />
      </div>

      <div class="p-4 bg-white mt-3 shadow-sm rounded">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="m-0">Customer Rank</h3>
          <div class="table-tools d-flex">
            <button class="btn btn-sm btn-outline-secondary me-2" @click="fetchData">
              <i class="fa fa-refresh me-1"></i> Refresh
            </button>

            <button class="btn btn-sm btn-primary" @click="toggleForm">
              <i class="fa fa-plus"></i> Add
            </button>
          </div>
        </div>

        <BaseTable
          storage-key="customer-ranks"
          :columns="tableCols"
          :data="tableData"
          :loading="loading"
          :total-items="total"
          v-model:current-page="allParams.page"
          v-model:page-size="allParams.limit"
          show-checkbox
          @sort="handleSort"
          @selection-change="handleSelection"
        >
          <template #cell(status)="{ item }">
            <span :class="item.status === 'Active' ? 'badge bg-success' : 'badge bg-secondary'">
              {{ item.status }}
            </span>
          </template>

          <template #actions="{ item }">
            <button class="btn btn-sm btn-primary me-1" @click="editCustomerRank(item)">
              <i class="fa fa-edit"></i>
            </button>
          </template>
        </BaseTable>
      </div>
    </div>
    <Form
      :isOpen="isShowForm"
      :itemData="selectedItem"  @close="isShowForm = false"
      @save="handleSaveData"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';

// Import các Component dùng chung
import BaseFilter from "@/components/common/BaseFilter.vue";
import BaseTable from "@/components/common/BaseTable.vue";
import { useCustomerRank } from "@/composables/useCustomerRank";
import Form from './Form.vue'
import { createToaster } from "@meforma/vue-toaster";

const toaster = createToaster({
    position: "top-right",
    duration: 2000,
});
// --- PHẦN STATE (DỮ LIỆU) ---
const { createCustomerRankApi, updateCustomerRankApi, getCustomerRanksApi } = useCustomerRank();
const filtered = ref(false);
const loading = ref(false);
const tableData = ref([]);
const total = ref(0);
const isShowForm = ref(false)
const selectedItem = ref(null);

// Gộp tất cả params vào 1 nơi để quản lý tập trung
const allParams = reactive({
  // Phân trang & Sort
  page: 1,
  limit: 10,
  orderBy: 'id',
  sortedBy: 'desc',
  order: '',
  // Lọc dữ liệu
  keyword: '',
  category: '',
  reportDate: '',
  startDate: '',
  endDate: '',
  search: '',
  searchFields: ''
});

const filterConfig = [
  {
    key: 'name',
    type: 'text',
    label: 'Name',
    operator: 'like',
    placeholder: 'Search by rank name...',
    isDefault: true
  }
];

// Cấu hình các cột của Bảng
const tableCols = [
  { key: 'id', label: 'ID', width: '70px', sortable: true },
  { key: 'name', label: 'Họ Tên', sortable: true },
  { key: 'email', label: 'Email' },
  { key: 'status', label: 'Trạng thái', align: 'center' },
  { key: 'actions', label: 'Thao tác', align: 'right', width: '120px' }
];

// --- PHẦN LOGIC (HÀNH ĐỘNG) ---

// Hàm gọi API (Gốc)
const fetchData = async (resetPage = false) => {
    if (resetPage) {
        allParams.page = 1;
    }

    loading.value = true;

    try {
        const res = await getCustomerRanksApi({ ...allParams });

        if (res.success && res.data) {
            tableData.value = res.data.data || [];

            total.value = res.data.meta?.pagination?.total || 0;
        } else {
            toaster.error(res.error || "Không thể tải dữ liệu");
        }
    } catch (err) {
        toaster.error("Có lỗi xảy ra trong quá trình kết nối");
    } finally {
        loading.value = false;
    }
};

const handleSearch = () => {
  if (allParams.page === 1) fetchData();
  else allParams.page = 1;
};

// Reset bộ lọc
const handleReset = () => {
  allParams.search = '';
  allParams.searchFields = '';
  
  if (allParams.page === 1) fetchData();
  else allParams.page = 1;
};

// Xử lý khi bấm vào tiêu đề cột để sắp xếp
const handleSort = ({ key, order }) => {
  allParams.orderBy = key;
  allParams.order = order;
  fetchData();
};

const handleSelection = (ids) => {
  console.log("IDs đã chọn:", ids);
};

const toggleForm = () => {
    selectedItem.value = null;
    isShowForm.value = !isShowForm.value
}
const handleSaveData = async (data) => {
    try {
        let res;
        if (data.id) {
            res = await updateCustomerRankApi(data.id, { name: data.name });
        } else {
            res = await createCustomerRankApi({ name: data.name });
        }

        if (res.success) {
            toaster.success(data.id ? "Cập nhật thành công!" : "Thêm mới thành công!");
            isShowForm.value = false;
            await fetchData();
        } else {
            toaster.error(res.error || "Thao tác thất bại");
        }
    } catch (err) {
        toaster.error("Có lỗi xảy ra trong quá trình kết nối");
    }
};
watch(() => [allParams.page, allParams.limit], () => {
    fetchData();
});

onMounted(fetchData);

const editCustomerRank = (item) => {
    selectedItem.value = { ...item };
    isShowForm.value = true;
};
</script>

<style scoped>
.filter-section .left-filter {
  max-height: 400px;
  overflow-y: auto;
  z-index: 99 !important;
}
.product-wrapper {
  padding-bottom: 50px;
}
</style>
